export const ESIGNATURE_TAB_KEY = 'eSignature'
